module.exports = __webpack_public_path__ + "media/images/lb/608-974c6cf639d05d92d95d735a94c92ead.svg";